<template>
  <div class="data_tabs">
    <a-tabs class="dataTab" type="card" style="background: #ffffff;">
      <a-tab-pane key="1" tab="设备信息" >
        <equipment-detail ref="equipmentDetail" :model="model"/>
      </a-tab-pane>
      <a-tab-pane key="2" tab="设备履历" >
        <business-information ref="BusinessInformation" :model="model"></business-information>
      </a-tab-pane>
      <a-tab-pane key="3" tab="业务履历" >
        <associate-assets ref="AssociateAssets" :model="model"></associate-assets>
      </a-tab-pane>
      <a-tab-pane key="4" tab="备件信息" >
        <spare-parts ref="spareParts" :model="model"></spare-parts>
      </a-tab-pane>
      <a-tab-pane key="5" tab="文档信息" >
        <document-info ref="documentInfo" :model="model"></document-info>
      </a-tab-pane>
      <a-tab-pane key="6" tab="设备层级" >
        <device-level-information :model="model"></device-level-information>
      </a-tab-pane>
      <a-tab-pane key="7" tab="二维码打印记录" >
        <!--  -->
      </a-tab-pane>
      <a-tab-pane key="8" tab="编辑记录" >
        <edit-record ref="editRecord" :model="model"></edit-record>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import DocumentInfo from './documentInfo.vue'
import equipmentDetail from './equipmentDetail.vue'
import SpareParts from './spareParts.vue'
import BusinessInformation from './businessInformation'
import AssociateAssets from './associateAssets'
import DeviceLevelInformation from '@/views/gasEquipment/modules/deviceLevelInformation'
import editRecord from './editRecord'
export default {
  props: {
    model: Object
  },
  components: {
    DeviceLevelInformation,
    AssociateAssets,
    BusinessInformation,
    equipmentDetail,
    SpareParts,
    DocumentInfo,
    editRecord
  },
  data  () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.data_tabs {
  height: 100%;
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
      }
      .ant-tabs-tab-active {
        color: #1791FF;
        background: rgba(23, 145, 255, 0.1);
      }
    }
  }
}
/deep/.dataTab {
  height: 100% !important;
  background-color: skyblue;
    >.ant-tabs-card-content {
      height: calc(100% - 40px);
      overflow-y: scroll;
      overflow-x: hidden;
    }
}
</style>
